import CheckIcon from "@mui/icons-material/Check";
import Tooltip from "@mui/material/Tooltip";

import useCustomerTools from "components/Screens/Marketplace/Customer/utils/useCustomerTools";
import { isMyTool } from "components/Screens/Marketplace/Customer/utils/tools";
import { andList } from "components/Screens/Marketplace/Customer/utils/preferenceTiles";
import type { SoftwareSkill } from "components/Screens/Marketplace/Customer/utils/dataMappers";

import "components/Screens/Marketplace/Customer/ProfileSection/ProfileContent.scss";

interface SoftwareSkillsSectionProps {
  /** One per tool (mapTalentToSoftwareSkills), with its logo when there is one. */
  skills: SoftwareSkill[];
}

/**
 * Software skills as the talent network showed them before PLG (product 2026-10-24): each tool's logo, or its name
 * where there is none, with the name on hover. "Knows X, like your team" above when any match the customer's tools.
 */
function SoftwareSkillsSection({ skills }: SoftwareSkillsSectionProps) {
  const myTools = useCustomerTools();
  const matched = skills.map((s) => s.name).filter((name) => isMyTool(name, myTools));

  return (
    <div id="software" className="profile-content__section">
      <div className="profile-content__title mb-075">Software Skills</div>
      {matched.length > 0 && (
        <div className="software-skills__match">
          <CheckIcon fontSize="inherit" />
          {`Knows ${andList(matched)}, like your team`}
        </div>
      )}
      <div className="software-skills__grid">
        {skills.map((skill) => (
          <Tooltip key={skill.name} title={skill.name} placement="top" arrow>
            <div className="software-skills__item">
              {skill.logoUrl ? (
                <div className="software-skills__image-container">
                  <img src={skill.logoUrl} alt={skill.name} className="software-skills__image" />
                </div>
              ) : (
                <div className="software-skills__name">{skill.name}</div>
              )}
            </div>
          </Tooltip>
        ))}
      </div>
    </div>
  );
}

export default SoftwareSkillsSection;
